import { render, staticRenderFns } from "./TeacherManager.vue?vue&type=template&id=ce252838&scoped=true&"
import script from "./TeacherManager.vue?vue&type=script&lang=js&"
export * from "./TeacherManager.vue?vue&type=script&lang=js&"
import style0 from "./TeacherManager.vue?vue&type=style&index=0&id=ce252838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce252838",
  null
  
)

export default component.exports